import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const PresetsWrapper = styled(FlexColumn)`
  gap: 24px;
  padding: 16px;

  max-height: 362px;

  overflow-x: hidden;
  overflow-y: scroll;

  ${QUERIES.largeTabletAndUp} {
    gap: 32px;
    padding: 33px 24px;
  }
`;
